import type { TourSpec } from "./types";

export const dropshipTour: TourSpec = {
  id: "dropship",
  version: 3,
  buildSteps: (t) => [
    {
      target: '[data-tour="dropship-region-progress"]',
      title: t("dropship.dataFreshness.title"),
      content: t("dropship.dataFreshness.body"),
      placement: "bottom",
      skipBeacon: true,
    },
    {
      target: '[data-tour="dropship-filter-sidebar"]',
      title: t("dropship.filters.title"),
      content: t("dropship.filters.body"),
      placement: "right",
    },
    {
      target: '[data-tour="filter-mode-toggle"]',
      title: t("filterMode.title"),
      content: t("filterMode.body"),
      placement: "right",
    },
    {
      target: '[data-tour="dropship-stats-section"]',
      title: t("dropship.stats.title"),
      content: t("dropship.stats.body"),
      placement: "bottom",
    },
    {
      target: '[data-tour="dropship-data-table"]',
      title: t("dropship.table.title"),
      content: t("dropship.table.body"),
      placement: "top",
    },
    {
      target: '[data-tour="row-actions-menu"]',
      title: t("rowActions.title"),
      content: t("rowActions.body"),
      placement: "bottom-start",
    },
    {
      target: '[data-tour="dropship-pagination"]',
      title: t("dropship.pagination.title"),
      content: t("dropship.pagination.body"),
      placement: "top",
    },
  ],
};
